@for (toast of toasts(); track toast) {
<ngb-toast
  [class]="`bg-${toast.color} text-${toast.color}-light `"
  [delay]="toast.delay || 5000"
  [autohide]="toast.delay != undefined"
  (hidden)="closeToast(toast.ref)"
  style="max-width: 500px;"
>
  <div class="d-flex flex-row align-items-center justify-content-between gap-2">
    <div class="d-flex flex-row align-items-center gap-2 fw-semibold">
      @if(toast.icon){
      <icon [icon]="toast.icon" />
      }
      <span>{{ toast.message.key | translate : toast.message.params }}</span>
    </div>
    @if(toast.delay == undefined){
    <icon
      [class]="`text-${toast.color}-light`"
      style="cursor: pointer"
      [icon]="icon"
      size="15"
      (click)="closeToast(toast.ref)"
    />
    }
  </div>
</ngb-toast>
}
